<template>
    <apex-chart type="line" height="350" :options="c_options" :series="c_series"></apex-chart>
</template>

<script>
import ApexChart from 'vue-apexcharts'
import moment from 'moment'
export default {
    props:{
        statistics:Object,
    },
    components:{
        ApexChart,
    },
    data(){
        return{
            colors:["#1F4690","#36AE7C","#EF5B0C","#ff9f43"]
        }
    },
    computed:{
        c_options(){
            let options = {
                chart:{toolbar: {show:false},},
                plotOptions: { bar: { horizontal: false, columnWidth: '55%', }, },
                dataLabels: { enabled: true },
                stroke: { show: true,  width: 4, colors: ['transparent'] },
                xaxis: { categories: this.statistics?.StatsByDate?.map(item=> moment(item.CreateDate).locale("tr").format("L")) || [], },
                fill: { opacity: 1 },
            }
            return options
        },
        c_series(){
            return [{
                name:this.statistics?.Plate,
                color:"#1F4690",
                data:this.statistics?.StatsByDate?.map(s=>s.Count) || []
            }]
        }
    }
}
</script>

<style>

</style>